/* tslint:disable */
/* eslint-disable */
/**
 * predictonco-backend API
 * predictonco-backend API
 *
 * The version of the OpenAPI document: 1.0.3
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PredictorInputBase
 */
export interface PredictorInputBase {
    /**
     * 
     * @type {string}
     * @memberof PredictorInputBase
     */
    id?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PredictorInputBase
     */
    structure?: boolean;
    /**
     * 
     * @type {PredictorInputBaseProteinTypeEnum}
     * @memberof PredictorInputBase
     */
    proteinType?: PredictorInputBaseProteinTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof PredictorInputBase
     */
    essential?: boolean;
    /**
     * 
     * @type {PredictorInputBaseDomainEnum}
     * @memberof PredictorInputBase
     */
    domain?: PredictorInputBaseDomainEnum;
    /**
     * 
     * @type {number}
     * @memberof PredictorInputBase
     */
    predictsnp: number;
    /**
     * 
     * @type {number}
     * @memberof PredictorInputBase
     */
    essentialResiduesAll?: number;
    /**
     * 
     * @type {number}
     * @memberof PredictorInputBase
     */
    conservation?: number;
    /**
     * 
     * @type {number}
     * @memberof PredictorInputBase
     */
    msaData?: number;
}


/**
 * @export
 */
export const PredictorInputBaseProteinTypeEnum = {
    ProtoOncogene: 'PROTO_ONCOGENE',
    TumorSuppressor: 'TUMOR_SUPPRESSOR'
} as const;
export type PredictorInputBaseProteinTypeEnum = typeof PredictorInputBaseProteinTypeEnum[keyof typeof PredictorInputBaseProteinTypeEnum];

/**
 * @export
 */
export const PredictorInputBaseDomainEnum = {
    Cytoplasmic: 'cytoplasmic',
    Extracellular: 'extracellular',
    Transmembrane: 'transmembrane',
    Other: 'other'
} as const;
export type PredictorInputBaseDomainEnum = typeof PredictorInputBaseDomainEnum[keyof typeof PredictorInputBaseDomainEnum];


/**
 * Check if a given object implements the PredictorInputBase interface.
 */
export function instanceOfPredictorInputBase(value: object): value is PredictorInputBase {
    if (!('predictsnp' in value) || value['predictsnp'] === undefined) return false;
    return true;
}

export function PredictorInputBaseFromJSON(json: any): PredictorInputBase {
    return PredictorInputBaseFromJSONTyped(json, false);
}

export function PredictorInputBaseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PredictorInputBase {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'structure': json['structure'] == null ? undefined : json['structure'],
        'proteinType': json['protein_type'] == null ? undefined : json['protein_type'],
        'essential': json['essential'] == null ? undefined : json['essential'],
        'domain': json['domain'] == null ? undefined : json['domain'],
        'predictsnp': json['predictsnp'],
        'essentialResiduesAll': json['essential_residues_all'] == null ? undefined : json['essential_residues_all'],
        'conservation': json['conservation'] == null ? undefined : json['conservation'],
        'msaData': json['msa_data'] == null ? undefined : json['msa_data'],
    };
}

export function PredictorInputBaseToJSON(json: any): PredictorInputBase {
    return PredictorInputBaseToJSONTyped(json, false);
}

export function PredictorInputBaseToJSONTyped(value?: PredictorInputBase | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'structure': value['structure'],
        'protein_type': value['proteinType'],
        'essential': value['essential'],
        'domain': value['domain'],
        'predictsnp': value['predictsnp'],
        'essential_residues_all': value['essentialResiduesAll'],
        'conservation': value['conservation'],
        'msa_data': value['msaData'],
    };
}

